import linkifyit from "linkify-it";
import React from "react";

type LinkifiedTextProps = {
	text: string;
	maxLinkLength?: number;
};

const linkify = new linkifyit();

const truncateUrl = (url: string, maxLength: number): string => {
	if (url.length <= maxLength) return url;
	return `${url.slice(0, maxLength)}…`;
};

/**
 * Renders plain text with auto-detected URLs converted to clickable links.
 * Uses linkify-it for URL detection, following the same pattern as TextWithFormatting
 * in the PDF renderer.
 */
export const LinkifiedText = ({ text, maxLinkLength = 60 }: LinkifiedTextProps): React.ReactElement => {
	const matches = linkify.match(text);

	if (!matches) {
		return <>{text}</>;
	}

	const elements: React.ReactNode[] = [];
	let lastIndex = 0;

	for (const match of matches) {
		if (match.index > lastIndex) {
			elements.push(text.slice(lastIndex, match.index));
		}

		elements.push(
			<a
				key={`${match.index}-${match.lastIndex}`}
				href={match.url}
				target="_blank"
				rel="noopener noreferrer"
				className="text-primary-5 no-underline hover:underline"
			>
				{truncateUrl(match.text, maxLinkLength)}
			</a>
		);

		lastIndex = match.lastIndex;
	}

	if (lastIndex < text.length) {
		elements.push(text.slice(lastIndex));
	}

	return <>{elements}</>;
};
